// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/pro-solid-svg-icons';

// Hooks
import { useAppDispatch } from '../../../app/hooks';

// Features
import { clearSession } from '../../../features/session/sessionSlice';
import { clearChatHistory } from '../../../features/chat/chatSlice';

// Components
import StateScreen from './StateScreen';

/**
 * @function ErrorTokenExpired
 * Describe the component's function
 *
 * @example
 * return (
 *   <ErrorTokenExpired />
 * )
 */
function ErrorTokenExpired(): JSX.Element {
    const dispatch = useAppDispatch();

    function handleLeaveClick(event: any) {
        dispatch(clearSession());
        dispatch(clearChatHistory());
        event.preventDefault();
    }

    return (
        <StateScreen
            icon={<FontAwesomeIcon icon={faBan} />}
            title="Sorry, you don't have enough points to enter this session"
        >
            <p>
                Please{' '}
                <a href="#" onClick={(e) => handleLeaveClick(e)}>
                    return to the lobby
                </a>{' '}
                and choose another session.
            </p>
        </StateScreen>
    );
}

// Exports
export default ErrorTokenExpired;
